<template>
  <div class="home-page">
    <!-- 圖片輪播 -->
    <section class="carousel-section">
      <SiteCarousel />
    </section>

    <!-- 三個信息區塊 -->
    <section class="info-section">
      <div class="container">
        <div class="info-grid">
          <div class="info-card">
            <div class="info-header">
              <span class="info-icon">👥</span>
              <h3 class="info-title">{{ $t('home.title_1') }}</h3>
            </div>
            <p class="info-content">{{ $t('home.content_1') }}</p>
          </div>
          <div class="info-card">
            <div class="info-header">
              <span class="info-icon">🔨</span>
              <h3 class="info-title">{{ $t('home.title_2') }}</h3>
            </div>
            <p class="info-content">{{ $t('home.content_2') }}</p>
          </div>
          <div class="info-card">
            <div class="info-header">
              <h3 class="info-title info-title-empty">{{ $t('home.title_3') }}</h3>
            </div>
            <p class="info-content info-content-bold">{{ $t('home.content_3') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import SiteCarousel from '@/components/SiteCarousel.vue'
</script>

<style scoped>
.home-page {
  width: 100%;
}

.carousel-section {
  width: 100%;
  margin-bottom: 40px;
}

.info-section {
  width: 100%;
  background-color: #f5f5f5;
  padding: 40px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.info-card {
  background: white;
  border-radius: 8px;
  padding: 30px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.info-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.info-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.info-icon {
  font-size: 1.8rem;
  display: flex;
  align-items: center;
}

.info-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.info-title-empty {
  display: none;
}

.info-content {
  font-size: 0.95rem;
  line-height: 1.6;
  color: #666;
  margin: 0;
  white-space: pre-line;
}

.info-content-bold {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
}

/* 手機版 */
@media (max-width: 768px) {
  .carousel-section {
    margin-bottom: 30px;
  }

  .info-section {
    padding: 30px 0;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .info-card {
    padding: 20px 15px;
  }

  .info-header {
    gap: 8px;
    margin-bottom: 12px;
  }

  .info-icon {
    font-size: 1.5rem;
  }

  .info-title {
    font-size: 1.1rem;
  }

  .info-content {
    font-size: 0.9rem;
  }

  .info-content-bold {
    font-size: 1.1rem;
  }
}
</style>
